/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("./Dialog.js"),t=require("./DialogActionsBar.js"),o=require("./Window.js"),n=require("./WindowActionsBar.js");exports.Dialog=i.Dialog;exports.DialogPropsContext=i.DialogPropsContext;exports.DialogActionsBar=t.DialogActionsBar;exports.Window=o.Window;exports.WindowPropsContext=o.WindowPropsContext;exports.WindowWithoutContext=o.WindowWithoutContext;exports.WindowActionsBar=n.WindowActionsBar;
